import { render, staticRenderFns } from "./Edittag.vue?vue&type=template&id=53e50d5d&scoped=true&"
import script from "./Edittag.vue?vue&type=script&lang=js&"
export * from "./Edittag.vue?vue&type=script&lang=js&"
import style0 from "./Edittag.vue?vue&type=style&index=0&id=53e50d5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e50d5d",
  null
  
)

/* custom blocks */
import block0 from "./Edittag.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports